import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './Pages/Home/Home';
import NotFound from './Pages/NotFound/NotFound';
import Nav from './Pages/Home/Nav';
import Blog from './Pages/Blog/Blog';
import Contact from './Pages/Home/Contact';
import Footer from './Pages/Home/Footer';
import Projects from './Pages/Home/Projects';
import Skills from './Pages/Home/Skills';
import EntWarehouse from './Pages/Projets/EntWarehouse';
import AboutMe from './Pages/Home/AboutMe';
import GamersPulse from './Pages/Projets/GamersPulse';
import SoloTraveller from './Pages/Projets/SoloTraveller';
import MotorParts from './Pages/Projets/MotoParts';

function App() {
  return (
    <div>
      <Nav></Nav>
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/home' element={<Home></Home>}></Route>
        {/* <Route path='/contact' element={<Contact></Contact>}></Route> */}
        <Route path='/blog' element={<Blog></Blog>}></Route>
        <Route path='/skill' element={<Skills></Skills>}></Route>
        <Route path='/project' element={<Projects></Projects>}></Route>
        <Route path='/contact' element={<Contact></Contact>}></Route>
        <Route path='/motor-parts-manufacturer' element={<MotorParts></MotorParts>}></Route>
        <Route path='/ent-warehouse' element={<EntWarehouse></EntWarehouse>}></Route>
        <Route path='/solo-traveller' element={<SoloTraveller></SoloTraveller>}></Route>
        <Route path='/gamers-pulse' element={<GamersPulse></GamersPulse>}></Route>
        <Route path='/contact' element={<Contact></Contact>}></Route>
        <Route path='/me' element={<AboutMe></AboutMe>}></Route>
        <Route path='*' element={<NotFound></NotFound>}></Route>
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;
